import React from "react";
import FilePicker from "components/FilePicker";
import get from "lodash/get";
import { useFormikContext } from "formik";
import { getFieldPath } from "utils/form";
import { MIMETYPE, PICKER_OPTIONS, PROMPTS } from "utils/constants/attachment";

const ImagesFields = ({ name }) => {
  const {
    values,
    touched,
    setFieldTouched,
    setFieldValue
  } = useFormikContext();
  const imagesFieldPath = getFieldPath(name, "images");
  const images = get(values, imagesFieldPath);

  return (
    <FilePicker
      pickerOptions={PICKER_OPTIONS.IMAGES}
      prompts={PROMPTS.IMAGES}
      mimetype={MIMETYPE.IMAGE_ALL}
      src={images && images[0]}
      onPickerDone={(images) => {
        setFieldValue(
          imagesFieldPath,
          images.map(({ url }) => url)
        );
        const isTouched = get(touched, imagesFieldPath);
        if (!isTouched) {
          setFieldTouched(imagesFieldPath, true);
        }
      }}
    />
  );
};

export default ImagesFields;
